import { createJSONStorage } from 'zustand/middleware';
import { StateStorage } from 'zustand/middleware/persist';

export const createSerializableStorage = <T>(storage: StateStorage) =>
  createJSONStorage<T>(() => storage, {
    replacer: (_, value) => {
      if (value instanceof Map) {
        return {
          type: 'Map',
          value: Array.from(value.entries()),
        };
      }
      return value;
    },
    reviver: (_, value) => {
      if (isSerializedMap(value)) {
        return new Map((value as { value: [unknown, unknown][] }).value);
      }
      return value;
    },
  });

type SerializedMap = {
  type: 'Map';
  value: [unknown, unknown][];
};

const isSerializedMap = (value: unknown): value is SerializedMap => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'type' in value &&
    (value as SerializedMap).type === 'Map' &&
    'value' in value &&
    Array.isArray((value as SerializedMap).value)
  );
};
